import React, {useState, useCallback, useEffect, useImperativeHandle, forwardRef, useMemo} from "../../__snowpack__/pkg/react.js";
import {Table, message} from "../../__snowpack__/pkg/antd.js";
import {axios} from "../lib/axios.js";
import {localeMessage as GlobalLocaleMessage} from "../i18n/i18n.js";
import {useIntlTyped} from "../lib/useIntlTyped.js";
export const TableList = forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const {formatMessage: GlobalFormatMessage} = useIntlTyped(GlobalLocaleMessage);
  useImperativeHandle(ref, () => ({
    handleQuery
  }));
  const handleChangePage = useCallback((page2, pageSize2) => {
    setPage(page2);
    setPageSize(pageSize2);
  }, []);
  const pagination = useMemo(() => {
    return {
      showSizeChanger: true,
      showTotal: (total2) => {
        return GlobalFormatMessage({id: "globalsTotalPage"}, {total: total2});
      },
      current: page,
      pageSize,
      total,
      onChange: handleChangePage,
      pageSizeOptions: ["10", "50", "100"]
    };
  }, [page, pageSize, total]);
  const handleQuery = useCallback(async (otherParams) => {
    setIsLoading(true);
    let params = {
      ...props.apiParam,
      ...otherParams
    };
    let apiMethod = props.apiMethod || "get";
    let queryPromise;
    if (props.isShowPage) {
      params.page = page;
      params.pageSize = pageSize;
    }
    if (props.formatParam) {
      params = props.formatParam(params);
    }
    if (apiMethod === "get") {
      queryPromise = axios[apiMethod](props.apiUrl, {
        params
      });
    } else {
      queryPromise = axios[apiMethod](props.apiUrl, params);
    }
    queryPromise.then((data) => {
      setIsLoading(false);
      props.formRef?.current?.onSearchRequestCallback && props.formRef.current.onSearchRequestCallback();
      if (data.code === "SUCCESS") {
        if (props.isShowPage) {
          setPage(data?.data?.number + 1);
          setPageSize(data?.data?.size);
          setTotal(data?.data?.totalElements);
        }
        setList(data?.data);
      } else {
        message.error(data.message);
      }
    }).catch((e) => {
      setList([]);
      setIsLoading(false);
      message.error(e.toString());
      props.formRef?.current?.onSearchRequestCatchCallback && props.formRef.current.onSearchRequestCatchCallback();
    });
  }, [props.apiUrl, props.apiParam, page, pageSize]);
  useEffect(() => {
    setList([]);
    if (props.searchCondition) {
      props.searchCondition() && props.apiUrl && handleQuery();
    } else {
      props.apiUrl && handleQuery();
    }
  }, [page, pageSize]);
  return /* @__PURE__ */ React.createElement(Table, {
    scroll: {x: "max-content"},
    loading: isLoading,
    dataSource: props.filterDataSource && props.filterDataSource(list) || list,
    pagination: !!props.isShowPage && pagination,
    columns: props.columns,
    ...props
  });
});
